// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgFatCrossIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M18 20c-.51 0-1.02-.2-1.42-.59L12 14.83l-4.58 4.58c-.78.78-2.05.78-2.83 0s-.78-2.05 0-2.83L9.17 12 4.59 7.42c-.79-.78-.79-2.05 0-2.83s2.05-.79 2.83 0L12 9.17l4.58-4.58c.78-.78 2.05-.78 2.83 0s.78 2.05 0 2.83L14.83 12l4.58 4.58A2.004 2.004 0 0 1 17.99 20z" />
  </g>
);
export default SvgFatCrossIcon;
SvgFatCrossIcon.displayName = 'SvgFatCrossIcon';
